/**
 * Builds a full address string from an address data object.
 *
 * @param {Object} addressData - The address data object.
 * @param {string} [addressData.address] - The street address.
 * @param {string} [addressData.city] - The city name.
 * @param {string} [addressData.state] - The state or region.
 * @param {string} [addressData.postalCode] - The postal or ZIP code.
 * @returns {string} The full address as a comma-separated string.
 */
export const buildFullAddress = (addressData) => {
	const fullAddress = [];
	const keys = ['address', 'city', 'state', 'postalCode'];
	keys.forEach((key) => {
		if (addressData[key]) {
			fullAddress.push(addressData[key]);
		}
	});
	return fullAddress.join(', ');
};
